<template v-once>
  <svg class="arrow-vect" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 19">
    <polyline fill="none" stroke="#FFF" stroke-width="3" points="2 1 10 9.524 2 18" transform="rotate(-180 6 9.5)"/>
  </svg>
</template>

<script>
  export default {
    name: 'ArrowVect'
  }
</script>



// WEBPACK FOOTER //
// src/components/svg/ArrowVect.vue